import { useMemo } from "react";
import { buildApiHeaders } from "../utils/apiHeaders";

/**
 * Generates API request headers.
 * Also sends X-User-Display-Name so the backend can stamp UpdatedBy on secrets.
 */
export function useApiHeaders(
  accessToken,
  roles,
  platformName,
  vaultId,
  awsProfile,
  userDisplayName = ""
) {
  const rolesKey = roles?.join(",") ?? "";

  return useMemo(
    () => buildApiHeaders({ accessToken, roles, platformName, vaultId, awsProfile, userDisplayName }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accessToken, rolesKey, platformName, vaultId, awsProfile, userDisplayName]
  );
}
